function getNestedValueRecursive(object, keys, index) {
    if (object == undefined)
        return undefined;
    if (index >= keys.length) {
        return object;
    }
    if (Array.isArray(object)) {
        const results = [];
        for (const element of object) {
            results.push(getNestedValueRecursive(element, keys, index));
        }
        return results.flat(Infinity);
    }
    if (typeof object === 'object') {
        const nextKey = keys[index];
        const nextValue = object[nextKey];
        return getNestedValueRecursive(nextValue, keys, index + 1);
    }
    return undefined;
}
export function getNestedValue(object, path) {
    if (!path)
        return object;
    const keys = path.split('.');
    return getNestedValueRecursive(object, keys, 0);
}
